import React, { useEffect, useState, useCallback, useRef } from 'react';
import styles from './index.less';
import Desc from './component/desc/index';
import Logo from '../../assets/airpods.png';
import Zalo from '../../assets/zalo.png';
import Failed from '../../assets/failed.png';
import whatsApp from '../../assets/whatsApp.png';
import warn from '../../assets/warn.png';
import bankList from '../../assets/bankList.png';
import bankLogo from '../../assets/bankLogo.png';
import useCustomSearchParams from '../../hook/index';
import formatCurrency from '../../utils/spilt';
import { Toast } from 'antd-mobile';
import Loading from '../../components/Loading';
import api from '../../utils/request';
import { decrypt } from '../../utils/qr';
import useLongPress from '../../hook/longPress';
import api_back from 'utils/request_back';
import ImageLoader from "../../components/ImageLoader";

import COMPANY_LOGO_URL from '../../assets/companyLogoUrl.png'; // logo小图标默认选择本地

const isProduction = process.env.NODE_ENV === 'production';

const Index = () => {
  const searchParams = useCustomSearchParams();
  const [visible, setVisible] = useState<boolean>(false);
  const [paymentInfo, setPaymentInfo] = useState({
    originalAmount: '',
    repayAmount: '',
    orderNo: '',
    expireDate: '',
    bankBranch: '',
    bankName: '',
    accountUser: '',
    bankNo: '',
    qrCode: null,
    userName: '',
    phone: '',
    customerZalo: '',
    customerPhone: '',
    appName: '',
    productName: '',
    fixedAmountSign: '',
    companyLogoUrl: COMPANY_LOGO_URL
  });


  const [qrDataLoadEnable, setQrDataLoadEnable] = useState(false)
  const qrDataParamRef = useRef({
    acqId: '',
    accountNo: '',
    accountName: '',
    amount: '',
    addInfo: '',
    logoUrl: '',
  });
  const [loading, setLoading] = useState<boolean>(false);
  // qr api加载的
  const [qrLoading, setQrLoading] = useState(true);
  // qr 外链加载的
  const [qrLinkLoading, setQrLinkLoading] = useState(true);
  const [loadFailed, setLoadFailed] = useState(false);
  const [src, setSrc] = useState('');
  const list = [
    {
      title: 'Tên ngân hàng',
      subTitle: paymentInfo.bankName,
      id: '00000',
      isLast: false,
    },
    {
      title: 'Tên chi nhánh',
      subTitle: paymentInfo.bankBranch,
      id: '22222',
      isLast: false,
    },
    {
      title: 'Tên chủ thẻ',
      subTitle: paymentInfo.accountUser,
      id: '33333',
      isLast: false,
    },
    {
      title: 'Tài khoản ngân hàng',
      subTitle: paymentInfo.bankNo,
      id: '22222555',
      isLast: true,
    },
  ];

  useEffect(() => {
    const orderId = searchParams.get('t');
    getOrderInfo(orderId);
  }, [searchParams]);


  const getOrderInfo = async (id: any) => {
    setLoading(true);
    try {
      const res = await api_back.get('/api/finance/h5/pay/log/repay/link/param/get?id=' + id);
      console.log('================================ order id : ' + id);
      console.log(res);
      if (res.status === 200) {
        const data = res.data;
        const code = data.code;
        if (code === 200) {
          const orderInfo = data.data;

          let originalAmount = searchParams.get('repayAmount');
          let repayAmount = formatCurrency(Number(originalAmount)) || '';
          let orderNo = searchParams.get('orderNo');
          let expireDate = searchParams.get('expireDate');
          let bankBranch = searchParams.get('bankBranch');
          let bankName = searchParams.get('bankName');
          let accountUser = searchParams.get('accountUser');
          let bankNo = searchParams.get('bankNo');
          let qrCode = searchParams.get('qrCode');
          let userName = searchParams.get('userName');
          let phone = searchParams.get('phone');
          let customerZalo = searchParams.get('customerZalo');
          let customerPhone = searchParams.get('customerPhone') || '';
          let appName = searchParams.get('appName') || '';
          let productName = searchParams.get('productName') || '';
          let fixedAmountSign = searchParams.get('fixedAmountSign') || '';
          // qr
          let acqId = searchParams.get('acqId') || '';
          let accountNo = searchParams.get('accountNo') || '';
          let accountName = searchParams.get('accountName') || '';
          let amount = searchParams.get('amount') || '';
          let addInfo = searchParams.get('addInfo') || '';
          let logoUrl = searchParams.get('logoUrl') || '';
          let qrPicUrl = '';
          let companyLogoUrl = ''

          if (orderInfo !== undefined && orderInfo !== null) {
            originalAmount = orderInfo.repayAmount;
            repayAmount = formatCurrency(Number(originalAmount)) || '';
            orderNo = orderInfo.orderNo;
            expireDate = orderInfo.expireDate;
            bankBranch = orderInfo.bankBranch;
            bankName = orderInfo.bankName;
            accountUser = orderInfo.accountUser;
            bankNo = orderInfo.bankNo;
            qrCode = orderInfo.qrCode;
            userName = orderInfo.userName;
            phone = orderInfo.phone;
            customerZalo = orderInfo.customerZalo;
            customerPhone = orderInfo.customerPhone || '';
            appName = orderInfo.appName || '';
            productName = orderInfo.productName || '';
            fixedAmountSign = orderInfo.fixedAmountSign || '';
            acqId = orderInfo.acqId || '';
            accountNo = orderInfo.accountNo || '';
            accountName = orderInfo.accountName || '';
            amount = orderInfo.amount || '';
            addInfo = orderInfo.addInfo || '';
            logoUrl = orderInfo.logoUrl || '';
            qrPicUrl = orderInfo.qrPicUrl || '';
            companyLogoUrl = orderInfo.companyLogoUrl;
          }

          setPaymentInfo({
            originalAmount: originalAmount || '',
            repayAmount: repayAmount || '',
            orderNo: orderNo || '',
            expireDate: expireDate || '',
            bankBranch: bankBranch || '',
            bankName: bankName || '',
            accountUser: accountUser || '',
            bankNo: bankNo || '',
            qrCode: qrCode ? JSON.parse(decodeURIComponent(qrCode)) : null,
            userName: userName || '',
            phone: phone || '',
            customerZalo: customerZalo || '',
            customerPhone: customerPhone || '',
            appName: appName || '',
            productName: productName || '',
            fixedAmountSign: fixedAmountSign || '',
            companyLogoUrl: companyLogoUrl || COMPANY_LOGO_URL,
          });

          console.log(qrPicUrl)
          if (qrPicUrl) {
            setQrDataLoadEnable(false)
            setSrc(qrPicUrl);
          } else {
            setQrDataLoadEnable(true)
            qrDataParamRef.current = {
              acqId: acqId || '',
              accountNo: accountNo || '',
              accountName: accountName || '',
              amount: amount || '',
              addInfo: addInfo || '',
              logoUrl: logoUrl || '',
            }
            await getQRCode()
          }
        }
      }
    } catch (e) {
      console.log(e);
      setLoadFailed(true);
    }
    setLoading(false);
  };

  const getQRCode = async () => {
    setQrLoading(true);
    try {
      interface generateData {
        date: string;
        qrData: string;
        token: string;
      }
      const qrData = qrDataParamRef.current
      const props = {
        acqId: qrData.acqId,
        accountNo: paymentInfo.bankNo,
        accountName: paymentInfo.accountUser,
        ...(paymentInfo.fixedAmountSign === '1' && { amount: paymentInfo.originalAmount }),
        ...(qrData.addInfo && { addInfo: qrData.addInfo }),
        logoUrl: qrData.logoUrl,
      };
      const res = await api.post('/api/jx/pay-qr/generate', props);
      console.log(res);
      if (res.status === 200) {
        const { date, qrData, token }: generateData = res.data;
        const data = decrypt(qrData, date, token);
        console.log(data);
        const src = 'data:image/gif;base64,' + data.qrBase64;
        setSrc(src);
        setLoadFailed(false);
      }
    } catch (e) {
      console.log(e);
      setLoadFailed(true);
    }
    setQrLoading(false);
  };
  const handleDownloadQr = useLongPress(
    () => { },
    () => { },
    {
      shouldPreventDefault: true,
      delay: 500,
    }
  );
  const handleCopyZalo = async () => {
    const { customerZalo } = paymentInfo;
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(customerZalo);
        Toast.show({
          icon: 'success',
          content: 'Đã sao chép Zalo thành công',
        });
      } catch (err) {
        Toast.show({
          icon: 'fail',
          content: 'Sao chép không thành công',
        });
      }
    } else {
      // 旧方法
      const textArea = document.createElement('textarea');
      textArea.value = customerZalo;
      textArea.style.position = 'fixed'; // 避免滚动到底部
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        Toast.show({
          icon: 'success',
          content: 'Đã sao chép Zalo thành công',
        });
      } catch (err) {
        Toast.show({
          icon: 'fail',
          content: 'Sao chép không thành công',
        });
      } finally {
        document.body.removeChild(textArea);
      }
    }
  };
  const handleCopyPhone = async () => {
    const { customerPhone } = paymentInfo;
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(customerPhone);
        Toast.show({
          icon: 'success',
          content: 'Đã sao chép Zalo thành công',
        });
      } catch (err) {
        Toast.show({
          icon: 'fail',
          content: 'Sao chép không thành công',
        });
      }
    } else {
      // 旧方法
      const textArea = document.createElement('textarea');
      textArea.value = customerPhone;
      textArea.style.position = 'fixed'; // 避免滚动到底部
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        Toast.show({
          icon: 'success',
          content: 'Đã sao chép Zalo thành công',
        });
      } catch (err) {
        Toast.show({
          icon: 'fail',
          content: 'Sao chép không thành công',
        });
      } finally {
        document.body.removeChild(textArea);
      }
    }
  };
  const hanleOpen = () => {
    setVisible(true);
  };
  const handleClose = () => {
    setVisible(false);
  };
  return (
    <div className={styles.container}>
      <div className={styles.paddingBox}>
        {/*<div className={styles.number}>*/}
        {/*    <span*/}
        {/*        className={styles.numberTitle}*/}
        {/*        style={{color: "##9D9D9D", fontWeight: 400}}*/}
        {/*    >*/}
        {/*      Số đơn đặt hàng:*/}
        {/*    </span>*/}
        {/*    <div className={styles.orderNo}>{paymentInfo.orderNo}</div>*/}
        {/*</div>*/}

        <div className={styles.topBankBox}>
          <img className={styles.logoImg} src={paymentInfo.companyLogoUrl} alt='bankLogo' />
          <div className={styles.orderNoBox}>
            <div className={styles.orderNoTitle}>Số đơn đặt hàng</div>
            <div className={styles.orderNoContent}>{paymentInfo.orderNo}</div>
          </div>
        </div>
      </div>

      <div className={styles.topSpace}>
        {/*<div className={styles.divider}></div>*/}
        <div className={styles.fieldBox}>
          <div className={styles.fieldTitle}>
            {' '}
            <span className={styles.numberTitle} style={{ color: '##9D9D9D', fontWeight: 400 }}>
              Tên:
            </span>
          </div>
          <div className={styles.fieldDesc}>{paymentInfo?.userName}</div>
        </div>
        <div className={styles.fieldBox}>
          <div className={styles.fieldTitle}>
            {' '}
            <span className={styles.numberTitle} style={{ color: '##9D9D9D', fontWeight: 400 }}>
              Số điện thoại:{' '}
            </span>
          </div>
          <div className={styles.fieldDesc}>{paymentInfo?.phone}</div>
        </div>
        <div className={styles.fieldBox}>
          <div className={styles.fieldTitle}>
            {' '}
            <span className={styles.numberTitle} style={{ color: '##9D9D9D', fontWeight: 400 }}>
              Tên ứng dụng:{' '}
            </span>
          </div>
          <div className={styles.fieldDesc}>{paymentInfo?.appName}</div>
        </div>
        <div className={styles.fieldBox}>
          <div className={styles.fieldTitle}>
            {' '}
            <span className={styles.numberTitle} style={{ color: '##9D9D9D', fontWeight: 400 }}>
              Tên sản phẩm:{' '}
            </span>
          </div>
          <div className={styles.fieldDesc}>{paymentInfo?.productName}</div>
        </div>
      </div>

      <div className={styles.paddingBox}>
        <div className={styles.amount}>
          <div className={styles.repayment}>
            <div className={styles.repaymentamount}>Số tiền hoàn trả</div>
            <div className={styles.vnd}>
              {paymentInfo.repayAmount} <span className={styles.unit}>vnd</span>
            </div>
          </div>
        </div>
        {qrDataLoadEnable ? (
          <div className={styles.QRCode}>
            <div className={styles.QRMain}>
              {/*<div className={styles.QRTitle}>QR code thanh toán</div>*/}
              <div className={styles.QRContent}>
                <Loading isLoading={qrLoading}>
                  {!loadFailed ? (
                    <div className={styles.successBox}>
                      <div {...handleDownloadQr} className={styles.imgBox}>
                        <div className={styles.QRImgBg}>
                          <img src={src} alt='QRImg' />
                          <span className={styles.saveText}>Nhấn và giữ để lưu</span>
                        </div>
                      </div>
                      {/* <div className={styles.QRTips}>Vui lòng chụp màn hình và quét mã thanh toán trong ứng dụng ngân hàng.</div> */}
                      <div className={styles.QRTips}>
                        <div style={{ color: '#FF7701' }}>Chụp màn hình → Quét mã thanh toán trên app ngân hàng.</div>
                        <div>
                          <span>Không quét được? </span>
                          <span style={{ color: '#343434' }}>Sử dụng chức năng sao chép-dán bên dưới. </span>
                          <span>Đừng nhập thủ công, tránh lỗi!</span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className={styles.errorBox}>
                      <img className={styles.errImg} src={Failed} alt='QRImg' />
                    </div>
                  )}
                </Loading>
              </div>
              {!qrLoading && loadFailed && <div className={styles.QRErrorMessage}>Mã QR tải thất bại, bạn có thể chuyển khoản trực tiếp hoặc</div>}
              {loadFailed && (
                <div onClick={getQRCode} className={styles.QRRefresh}>
                  thử làm mới.
                </div>
              )}
              {/*<div className={styles.QRLine}></div>*/}
            </div>
          </div>
        ) : (
          !!src && (
            <div className={styles.QRCode}>
              <div className={styles.QRMain}>
                {/*<div className={styles.QRTitle}>QR code thanh toán</div>*/}
                <div className={styles.QRContent}>
                  <div className={styles.successBox}>
                    <div {...handleDownloadQr} className={styles.imgBox}>
                      <div className={styles.QRImgBg}>
                        <ImageLoader src={src} />
                        <span className={styles.saveText}>Nhấn và giữ để lưu</span>
                      </div>
                    </div>
                    {/* <div className={styles.QRTips}>Vui lòng chụp màn hình và quét mã thanh toán trong ứng dụng ngân hàng.</div> */}
                    <div className={styles.QRTips}>
                        <div style={{ color: '#FF7701' }}>Chụp màn hình → Quét mã thanh toán trên app ngân hàng.</div>
                        <div>
                          <span>Không quét được? </span>
                          <span style={{ color: '#343434' }}>Sử dụng chức năng sao chép-dán bên dưới. </span>
                          <span>Đừng nhập thủ công, tránh lỗi!</span>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          )
        )}

        <div className={styles.officialRepayment}>
          <div className={styles.officialTitle}>Tài khoản ngân hàng chính thức</div>
          <div className={styles.officialDesc}>Vui lòng chuyển số tiền thanh toán của bạn vào tài khoản ngân hàng chính thức sau đây.</div>
        </div>
        <div className={styles.name}>
          {list.map((item, index) => {
            return <Desc id={item.id} title={item.title} subtitle={item.subTitle} key={item.id} isLast={item.isLast} />;
          })}
        </div>
        <div className={styles.remark}>
          <img src={warn} alt='warn' />
          <span>Chúng tôi sẽ xử lý đơn thẻ ngay khi nhận được thanh toán.</span>
        </div>
        {/*<div className={styles.scamTip}>*/}
        {/*    Lưu ý: Bất kỳ hình thức hoàn trả nào khác đều không phải của kênh chính*/}
        {/*    thức , vui lòng cảnh giác và tránh lừa đảo. Nếu có thắc mắc, vui lòng*/}
        {/*    liên hệ ngay với bộ phận chăm sóc khách hàng để xác minh*/}
        {/*</div>*/}

        <div className={styles.bottomDesc}>
          <div className={styles.leftDivider}></div>
          <div className={styles.middleDesc}>Liên hệ dịch vụ khách hàng.</div>
          <div className={styles.rightDivider}></div>
        </div>
        <div className={styles.logo}>
          <img src={Logo} alt='' className={styles.img} onClick={hanleOpen} />
        </div>
        <div className={styles.bottomTip}>Vui lòng hoàn trả qua kênh chính thức. Nếu có thắc mắc, xin liên hệ dịch vụ khách hàng để xác minh. Cảm ơn sự hợp tác của bạn!</div>
        <div className={styles.bottomDesc}>
          <div className={styles.leftDivider}></div>
          <div className={styles.middleDesc}>Hỗ trợ các ngân hàng chuyển tiền sau</div>
          <div className={styles.rightDivider}></div>
        </div>
        <div className={styles.bankList}>
          <img src={bankList} alt='bankList' />
        </div>
        {visible ? <div className={styles.mask} onClick={handleClose}></div> : null}
        {visible ? (
          <div className={styles.dialog}>
            <div className={styles.dialogZalo}>
              <div className={styles.dialogZaloText}>
                <img className={styles.zaloImg} src={Zalo} />
                <div className={styles.zaloDesc}>
                  <div className={styles.zaloDescTitle}>Zalo</div>
                  <div className={styles.zaloDescContent}>{paymentInfo.customerZalo}</div>
                </div>
              </div>
              <div className={styles.rightOpreate}>
                <button className={styles.copyRightButton} onClick={handleCopyZalo}>
                  Sao chép
                </button>
              </div>
            </div>
            <div className={styles.dialogDivider} />
            <div className={styles.dialogPhone}>
              <div className={styles.dialogZaloText}>
                <img className={styles.zaloImg} src={whatsApp} />
                <div className={styles.zaloDesc}>
                  <div className={styles.zaloDescTitle}>Điện thoại dịch vụ khách hàng</div>
                  <div className={styles.zaloDescContent}>{paymentInfo.customerPhone}</div>
                </div>
              </div>
              <div className={styles.rightOpreate}>
                <button className={styles.copyRightButton} onClick={handleCopyPhone}>
                  Sao chép
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default Index;



